import pipe from 'ramda/src/pipe'
import concat from 'ramda/src/concat'
import replace from 'ramda/src/replace'
import { httpsWwwRe } from 'root/src/shared/util/regexes'
import tryCatch from 'ramda/src/tryCatch'
import always from 'ramda/src/always'

export const removeProtocolAndWww = tryCatch(replace(httpsWwwRe, ''), always(undefined))
export const addHttpsProtocol = tryCatch(replace(httpsWwwRe, 'https://'), always(undefined))
export const addProtocolAndEscape = tryCatch(pipe(
	replace(/\//g, '%2F'),
	concat('https%3A%2F%2F'),
), always(undefined))
